<div class="content-card" [ngClass]="{'popup-content-card': isPopUp}">
    <div class="collection-wrapper">
      <div class="card ">
        <div class="row">
          <div class="col-md-6 title">
            {{'INSTALLATIONS.ASSIGN' | translate}}
          </div>
          <div class="col-md-6 close" (click)="closeModal()">
            {{'COMMON.CLOSE' | translate}}
          </div>
        </div>
        <div class="d-flex justify-content-center assignment-tabs">
          <div class="assignment-tab" *ngIf="permissionsService.isDtMeterInstallationVendorAssignmentAllowed"
            [ngClass]="{ active: selectedTab === AssignmentTab.Vendor }"
            (click)="setTab(AssignmentTab.Vendor)">
            <span>{{ 'INSTALLATIONS.VENDOR_ASSIGNMENT' | translate }}</span>
          </div>
          <div class="assignment-tab" *ngIf="permissionsService.isDtMeterInstallationCreateEditAllowed"
            [ngClass]="{ active: selectedTab === AssignmentTab.Installer }"
            (click)="setTab(AssignmentTab.Installer)">
            <span>{{ 'INSTALLATIONS.INSTALLER_ASSIGNMENT' | translate }}</span>
          </div>
        </div>
        <div class="form-wrapper">
            <div class="row">
              <div class="col-md-6 title">{{'INSTALLATIONS.SELECT_DTS' | translate}}</div>
               <div class="col-md-6 counter">{{selectedAssets.length}} {{'INSTALLATIONS.DTS_SELECTED' | translate}}</div>
            </div>
            <div class="groupSelect">
              <div class="search-input">
                <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()">
                <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchAssets" (keydown.enter)="search()" name="searchAssets">
              </div>
              <!-- show dts -->
              <div class="checkListBox">
                <div *ngFor="let asset of assetsForSelect" class="option"  [ngClass]="{'selected-bu': isChecked(asset.id), 'disabled-option': isAssetDisabled(asset)}">
                  <div class="row">
                    <div class="col-md-1">
                      <input type="checkbox" id="{{asset.id}}" (click)="onChangeAsset(asset);" [checked]="isChecked(asset.id)" [disabled]="isAssetDisabled(asset)" disableRipple name="selectedAssets"/>
                    </div>
                    <div class="col-md-11">
                      <label class="name">{{asset.name | hasValue}}</label><br>
                      <label class="address">{{'COMMON.CUSTOMER.DT_NUMBER' | translate}}: {{asset.number | hasValue}}</label><br>
                      <label class="address">{{'INSTALLATIONS.METER_NUMBER' | translate}}: {{asset.meterNumber | hasValue}}</label><br>
                      <label class="address">{{'COMMON.ADDRESS' | translate}}: {{asset.address | hasValue}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-floating form-item" *ngIf="selectedTab === AssignmentTab.Vendor">
              <input type="text" name="vendorFilterText" [(ngModel)]="vendorFilterText" class="form-control filter-field" [ngClass]="{'valid-input': tempVendorId != 0}" id="vendorInput" (ngModelChange)="filterVendors()" placeholder=" ">
              <label for="vendorInput">{{'INSTALLATIONS.VENDOR_NAME' | translate}}</label>

              <div class="filtered-agent-list" *ngIf="vendorFilterText.length > 2 && isVendorDropdownOpened" #dropdownContainer>
                <div click-stop-propagation class="agent-name" (click)="selectVendor(v.id)" *ngFor="let v of filteredVendors">{{v.name}}</div>
              </div>
            </div>

            <div class="form-floating form-item" *ngIf="selectedTab === AssignmentTab.Installer">
              <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control filter-field" [ngClass]="{'valid-input': tempAssignedUserId != 0}" id="floatingInput" (ngModelChange)="filterMobileUsers()" placeholder=" ">
              <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

              <div class="filtered-agent-list" *ngIf="filterText.length > 2 && isDropdownOpened" #dropdownContainer>
                <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)" *ngFor="let u of mobileUsersForSelect">{{u.fullName}}</div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary submit" [disabled]="(selectedTab === AssignmentTab.Vendor ? vendorFilterText.length === 0 : filterText.length === 0) || selectedAssets.length===0" (click)="selectedTab === AssignmentTab.Vendor ? submitVendor() : submit()">{{'INSTALLATIONS.ASSIGN_MORE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
